import { render } from "./PositionTabs.vue?vue&type=template&id=15aa3f77&scoped=true&ts=true"
import script from "./PositionTabs.vue?vue&type=script&lang=ts"
export * from "./PositionTabs.vue?vue&type=script&lang=ts"

import "./PositionTabs.vue?vue&type=style&index=0&id=15aa3f77&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15aa3f77"]])

export default __exports__